module.exports = __webpack_public_path__ + "static/media/empty-container.e83d9e7a.svg";